// Scheduler (Self, Manuala and Bulk Self Schedule) constants
export const STEP_STATUS_ACTIVE = 'active';
export const STEP_STATUS_PENDING = 'pending';
export const STEP_STATUS_COMPLETED = 'completed';
export const SCHEDULE_TYPE_SELF = 'self';
export const SCHEDULE_TYPE_BULK_SELF_SCHEDULE = 'bulk-self';
export const SCHEDULE_TYPE_BULK_MANUAL = 'bulk-manual';
export const SCHEDULE_TYPE_MANUAL = 'manual';
export const SCHEDULE_TYPE_AI_ADHOC = 'ai-adhoc';

const MANUAL_SCHEDULE_STEPS = [
  {
    label: 'Details',
    status: STEP_STATUS_ACTIVE, // 'active', 'completed', 'pending',
    enabled: true,
    componentRef: 'INTERVIEW_DETAILS',
    id: 'details',
    nextNode: 'invites',
    prevNode: null,
    submitButtonLabel: 'Next: Calendar invites',
  },
  {
    label: 'Calendar invites',
    status: STEP_STATUS_PENDING, // 'active', 'completed', 'pending',
    enabled: false,
    componentRef: 'INTERVIEW_INVITES',
    id: 'invites',
    prevNode: 'details',
    nextNode: null,
    submitButtonLabel: 'Schedule interview',
  },
];

const MANUAL_TRIGGER_ADHOC_STEPS = [
  {
    label: 'Details',
    status: STEP_STATUS_ACTIVE, // 'active', 'completed', 'pending',
    enabled: true,
    componentRef: 'INTERVIEW_DETAILS',
    id: 'details',
    prevNode: null,
    nextNode: 'invites',
    submitButtonLabel: 'Next: Calendar invites',
  },
  {
    label: 'Calendar invites',
    status: STEP_STATUS_PENDING, // 'active', 'completed', 'pending',
    enabled: false,
    componentRef: 'INTERVIEW_INVITES',
    id: 'invites',
    prevNode: 'details',
    nextNode: 'scorecard',
    submitButtonLabel: 'Next: Scorecard',
  },
  {
    label: 'Scorecard',
    status: STEP_STATUS_PENDING, // 'active', 'completed', 'pending',
    enabled: false,
    componentRef: 'INTERVIEW_SCORECARD',
    id: 'scorecard',
    prevNode: 'invites',
    nextNode: null,
    submitButtonLabel: 'Schedule interview',
  },
];

// Schedule with AI (ad-hoc): Details → Calendar invites → Scorecard → Schedule (coordinator)
const AI_ADHOC_STEPS = [
  {
    label: 'Details',
    status: STEP_STATUS_ACTIVE,
    enabled: true,
    componentRef: 'INTERVIEW_DETAILS',
    id: 'details',
    prevNode: null,
    nextNode: 'invites',
    submitButtonLabel: 'Next: Calendar invites',
  },
  {
    label: 'Calendar invites',
    status: STEP_STATUS_PENDING,
    enabled: false,
    componentRef: 'INTERVIEW_INVITES',
    id: 'invites',
    prevNode: 'details',
    nextNode: 'scorecard',
    submitButtonLabel: 'Next: Scorecard',
  },
  {
    label: 'Scorecard',
    status: STEP_STATUS_PENDING,
    enabled: false,
    componentRef: 'INTERVIEW_SCORECARD',
    id: 'scorecard',
    prevNode: 'invites',
    nextNode: 'schedule',
    submitButtonLabel: 'Next: Schedule',
  },
  {
    label: 'Schedule',
    status: STEP_STATUS_PENDING,
    enabled: false,
    componentRef: 'COORDINATOR_SCHEDULE',
    id: 'schedule',
    prevNode: 'scorecard',
    nextNode: null,
    submitButtonLabel: 'Send schedule',
    /** Shown when CoordinatorScheduleStep timing is `immediately` (label "Immediately"). */
    submitButtonLabelWhenTimingImmediate: 'Call now',
  },
];

const SELF_SCHEDULE_STEPS = [
  {
    label: 'Details',
    status: STEP_STATUS_ACTIVE, // 'active', 'completed', 'pending',
    enabled: true,
    componentRef: 'INTERVIEW_DETAILS',
    id: 'details',
    nextNode: 'emailToCandidate',
    prevNode: null,
    submitButtonLabel: 'Next: Email to candidate',
  },
  {
    label: 'Email to candidate',
    status: STEP_STATUS_PENDING, // 'active', 'completed', 'pending',
    enabled: true,
    componentRef: 'INTERVIEW_EMAIL_TO_CANDIDATE',
    id: 'emailToCandidate',
    prevNode: 'details',
    nextNode: 'invites',
    submitButtonLabel: 'Next: Calendar invites',
  },
  {
    label: 'Calendar invites',
    status: STEP_STATUS_PENDING, // 'active', 'completed', 'pending',
    enabled: false,
    componentRef: 'INTERVIEW_INVITES',
    id: 'invites',
    prevNode: 'emailToCandidate',
    nextNode: null,
    submitButtonLabel: 'Schedule meeting',
  },
];

const SELF_TRIGGER_ADHOC_STEPS = [
  {
    label: 'Details',
    status: STEP_STATUS_ACTIVE, // 'active', 'completed', 'pending',
    enabled: true,
    componentRef: 'INTERVIEW_DETAILS',
    id: 'details',
    nextNode: 'emailToCandidate',
    prevNode: null,
    submitButtonLabel: 'Next: Email to candidate',
  },
  {
    label: 'Email to candidate',
    status: STEP_STATUS_PENDING, // 'active', 'completed', 'pending',
    enabled: true,
    componentRef: 'INTERVIEW_EMAIL_TO_CANDIDATE',
    id: 'emailToCandidate',
    prevNode: 'details',
    nextNode: 'invites',
    submitButtonLabel: 'Next: Calendar invites',
  },
  {
    label: 'Calendar invites',
    status: STEP_STATUS_PENDING, // 'active', 'completed', 'pending',
    enabled: false,
    componentRef: 'INTERVIEW_INVITES',
    id: 'invites',
    prevNode: 'emailToCandidate',
    nextNode: 'scorecard',
    submitButtonLabel: 'Next: Scorecard',
  },
  {
    label: 'Scorecard',
    status: STEP_STATUS_PENDING, // 'active', 'completed', 'pending',
    enabled: false,
    componentRef: 'INTERVIEW_SCORECARD',
    id: 'scorecard',
    prevNode: 'invites',
    nextNode: null,
    submitButtonLabel: 'Schedule meeting',
  },
];

export const GET_SCHEDULE_STEPS = (scheduleType, isAdhoc = false) => {
  if (scheduleType === SCHEDULE_TYPE_AI_ADHOC) {
    return AI_ADHOC_STEPS;
  }
  if (scheduleType === SCHEDULE_TYPE_MANUAL && !isAdhoc) {
    return MANUAL_SCHEDULE_STEPS;
  } else if (scheduleType === SCHEDULE_TYPE_MANUAL && isAdhoc) {
    return MANUAL_TRIGGER_ADHOC_STEPS;
  } else if (scheduleType === SCHEDULE_TYPE_SELF && !isAdhoc) {
    return SELF_SCHEDULE_STEPS;
  } else if (scheduleType === SCHEDULE_TYPE_SELF && isAdhoc) {
    return SELF_TRIGGER_ADHOC_STEPS;
  } else if (scheduleType === SCHEDULE_TYPE_BULK_SELF_SCHEDULE) {
    return SELF_SCHEDULE_STEPS;
  } else {
    return MANUAL_SCHEDULE_STEPS; //
  }
};

export const SCHEDULE_FOR_HEADER = {
  [SCHEDULE_TYPE_SELF]: 'Select self-schedule slots for',
  [SCHEDULE_TYPE_BULK_SELF_SCHEDULE]: 'Select self-schedule slots for',
  [SCHEDULE_TYPE_MANUAL]: 'Set up the interview for',
  [SCHEDULE_TYPE_AI_ADHOC]: 'Schedule ad-hoc interview with AI',
};

// schedule all constants
export const SCHEDULE_ALL_STATE_DATE_RANGE = 'DATE_RANGE';
export const SCHEDULE_ALL_STATE_RECOMMENDATION = 'RECOMMENDATION';
export const SCHEDULE_ALL_DATE_RANGE_ADD_INTERVIEWERS = 'ADD_INTERVIEWERS';
export const SCHEDULE_ALL_DATE_RANGE_ADD_TIME_RANGE = 'ADD_TIME_RANGE';

export const SCHEDULE_TIME_RANGE_STEPS_WITH_INTERVIEWERS = [
  {
    label: 'Recommendation prerequisites',
    status: STEP_STATUS_ACTIVE, // 'active', 'completed', 'pending',
    enabled: true,
    componentRef: 'ADD_INTERVIEWERS_COMP',
    id: 'addInterviewers',
    nextNode: 'invites',
    prevNode: null,
    submitButtonLabel: 'Next: Add preferred dates and times',
  },
  {
    label: 'Add preferred dates and times',
    subLabel:
      'Get recommendations for your interviews within your preferred dates and times',
    status: STEP_STATUS_PENDING, // 'active', 'completed', 'pending',
    enabled: false,
    componentRef: 'DATE_RANGE_COMP',
    id: 'invites',
    prevNode: 'addInterviewers',
    nextNode: null,
    submitButtonLabel: 'See recommendations',
  },
];

export const SCHEDULE_TIME_RANGE_STEPS_WITHOUT_INTERVIEWERS = [
  {
    label: 'Add preferred dates and times',
    subLabel:
      'Get recommendations for your interviews within your preferred dates and times',
    status: STEP_STATUS_ACTIVE, // 'active', 'completed', 'pending',
    enabled: false,
    componentRef: 'DATE_RANGE_COMP',
    id: 'invites',
    prevNode: null,
    nextNode: null,
    submitButtonLabel: 'See recommendations',
  },
];

export const SCHEDULE_ALL_RECOMMENDATIONS_STEPS = [
  {
    label: 'Recommendations',
    status: STEP_STATUS_ACTIVE, // 'active', 'completed', 'pending',
    enabled: true,
    componentRef: 'RECOMMENDATION_SELECTION_COMP',
    id: 'recommendationSelection',
    nextNode: 'recommendationScheduleSelection',
    prevNode: null,
    submitButtonLabel: 'Next: Review and schedule',
  },
  {
    label: 'Review and schedule',
    status: STEP_STATUS_PENDING, // 'active', 'completed', 'pending',
    enabled: false,
    componentRef: 'RECOMMENDATION_SCHEDULE_COMP',
    id: 'recommendationScheduleSelection',
    prevNode: 'recommendationSelection',
    nextNode: null,
    submitButtonLabel: 'Next: Schedule all interviews',
  },
];
